<template>
  <p v-show="showTax" v-html="newlinesToHtmlBR(tax)" />
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { newlinesToHtmlBR } from '~/utility/newlinesToHtmlBR'

@Component
class BookingCityTax extends Vue {
  @Prop({ required: true })
  tax: string

  get showTax(): boolean {
    return this.tax !== ''
  }

  newlinesToHtmlBR(string) {
    return newlinesToHtmlBR(string)
  }
}

export default toNative(BookingCityTax)
</script>
